import { GoogleOneTap } from "@clerk/nextjs";
import PlausibleProvider from "next-plausible";
import { ThemeProvider } from "next-themes";
import type * as React from "react";

import AuthProvider from "./AuthProvider";

interface ComponentNameProps {
	children: React.ReactNode;
	pageProps?: Record<string, any>;
}

const Providers: React.FC<ComponentNameProps> = ({ children, pageProps }) => {
	return (
		<PlausibleProvider
			domain="brookbushinstitute.com"
			scriptProps={{
				src: "https://analytics.brookbushinstitute.com/js/script.js",
			}}
		>
			<ThemeProvider attribute="class" defaultTheme="light" storageKey="theme">
				<AuthProvider pageProps={pageProps}>
					<GoogleOneTap />

					{children}
				</AuthProvider>
			</ThemeProvider>
		</PlausibleProvider>
	);
};

export default Providers;
